/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Comma_LabelInputs */



/**
* | output |
* | --- |
* | "End event on comma" |
*
* @param {Plain_Text_Import_End_Event_Comma_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_comma_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Comma_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Comma_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer l'evenement sur virgule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis bei Komma beenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina l'evento con la virgola")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершить событие на запятой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento final en coma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("以逗号结束事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カンマでイベントを終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अल्पविराम पर घटना समाप्त करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fim do evento na vírgula")
	return /** @type {LocalizedString} */ ("End event on comma")
});